import axios from './axios'
import * as actionTypes from '../store/actions/actionTypes'

export const setupInterceptors = (store) => {
    axios.interceptors.response.use(
        function (response) {
            return response;
        }, function (error) {
            if (!error.response) {
                store.dispatch({ type: actionTypes.SET_SERVER_UNAVAILABLE, ifServerUnavailable: true });
            } else {
                store.dispatch({ type: actionTypes.SET_SERVER_UNAVAILABLE, ifServerUnavailable: false });
                if (error?.response?.status === 403) {
                    if (localStorage.getItem('user')) localStorage.removeItem('user')
                    if (localStorage.getItem('_expiredTime')) localStorage.removeItem('_expiredTime')
                    store.dispatch({ type: actionTypes.LOGOUT });
                }
            }

            return Promise.reject(error);
        });
}
